import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LangContext";

const reveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
};

const InvitationSection = () => {
  const { t } = useLang();
  return (
    <section className="py-28 md:py-40 px-6">
      <div className="max-w-3xl mx-auto text-center">
        <motion.h2 {...reveal} className="font-serif text-4xl md:text-5xl text-wine mb-10 leading-tight">
          {t.invitation.title}
        </motion.h2>
        <motion.div {...reveal} transition={{ ...reveal.transition, delay: 0.2 }} className="divider-gold mb-10" />
        <motion.p {...reveal} transition={{ ...reveal.transition, delay: 0.3 }} className="font-editorial text-xl md:text-2xl text-charcoal leading-relaxed italic whitespace-pre-line">
          {t.invitation.body}
        </motion.p>
      </div>
    </section>
  );
};

const VerseSection = () => {
  const { t } = useLang();
  return (
    <section
      data-testid="verse-section"
      className="py-28 md:py-40 px-6 relative overflow-hidden"
      style={{ backgroundColor: "#F4F0E6" }}
    >
      <div className="max-w-3xl mx-auto text-center relative z-10">
        <motion.p {...reveal} className="text-[11px] tracking-[0.4em] uppercase text-gold mb-8">
          {t.verse.label}
        </motion.p>
        <motion.blockquote
          {...reveal}
          transition={{ ...reveal.transition, delay: 0.15 }}
          className="font-editorial text-2xl md:text-3xl lg:text-4xl text-wine leading-[1.5] italic"
        >
          “{t.verse.text}”
        </motion.blockquote>
      </div>
      {/* Olive branch decorative SVGs */}
      <div className="absolute top-10 left-6 md:left-16 opacity-20 w-24 md:w-40 rotate-12">
        <Leaf />
      </div>
      <div className="absolute bottom-10 right-6 md:right-16 opacity-20 w-24 md:w-40 -rotate-12 scale-x-[-1]">
        <Leaf />
      </div>
    </section>
  );
};

const Leaf = () => (
  <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 100 Q60 40 180 30" stroke="#687059" strokeWidth="1.5" fill="none" />
    <ellipse cx="50" cy="80" rx="14" ry="6" fill="#687059" transform="rotate(-30 50 80)" />
    <ellipse cx="80" cy="60" rx="14" ry="6" fill="#687059" transform="rotate(-25 80 60)" />
    <ellipse cx="110" cy="48" rx="14" ry="6" fill="#687059" transform="rotate(-20 110 48)" />
    <ellipse cx="140" cy="38" rx="14" ry="6" fill="#687059" transform="rotate(-15 140 38)" />
    <ellipse cx="65" cy="100" rx="14" ry="6" fill="#687059" transform="rotate(30 65 100)" />
    <ellipse cx="95" cy="85" rx="14" ry="6" fill="#687059" transform="rotate(25 95 85)" />
    <ellipse cx="125" cy="70" rx="14" ry="6" fill="#687059" transform="rotate(20 125 70)" />
  </svg>
);

export { InvitationSection, VerseSection };
